"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-1ca2336e"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "overdue-detail"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ContractDetail = (0, vue_1.resolveComponent)("ContractDetail");
    const _component_CustomerDetail = (0, vue_1.resolveComponent)("CustomerDetail");
    const _component_GuaranteeList = (0, vue_1.resolveComponent)("GuaranteeList");
    const _component_OverdueContent = (0, vue_1.resolveComponent)("OverdueContent");
    const _component_VehicleDetail = (0, vue_1.resolveComponent)("VehicleDetail");
    const _component_LockVehicle = (0, vue_1.resolveComponent)("LockVehicle");
    const _component_DisposalApplication = (0, vue_1.resolveComponent)("DisposalApplication");
    const _component_CollectionList = (0, vue_1.resolveComponent)("CollectionList");
    const _component_ContactsList = (0, vue_1.resolveComponent)("ContactsList");
    const _component_LetterReminder = (0, vue_1.resolveComponent)("LetterReminder");
    const _component_MessageList = (0, vue_1.resolveComponent)("MessageList");
    const _component_GuarantorList = (0, vue_1.resolveComponent)("GuarantorList");
    const _component_DeductionList = (0, vue_1.resolveComponent)("DeductionList");
    return (_ctx.id && _ctx.detail)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            (_ctx.hasModule('contract'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ContractDetail, {
                    key: 0,
                    defaultCollapse: _ctx.defaultCollapse,
                    unOperate: _ctx.module !== true,
                    id: _ctx.detail.contractId,
                    extraData: { orgCustomerid: _ctx.detail.orgCustomerid, orgname: _ctx.detail.orgname, username2: _ctx.detail.username2, loanTime: _ctx.detail.loanTime }
                }, null, 8, ["defaultCollapse", "unOperate", "id", "extraData"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('customer'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CustomerDetail, {
                    key: 1,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.customerid,
                    extraData: _ctx.detail
                }, null, 8, ["defaultCollapse", "id", "extraData"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('guarantee'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_GuaranteeList, {
                    key: 2,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.projectId
                }, null, 8, ["defaultCollapse", "id"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('overdue'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_OverdueContent, {
                    key: 3,
                    defaultCollapse: _ctx.defaultCollapse,
                    unOperate: _ctx.module !== true,
                    style: { "margin-top": "24px" },
                    detail: _ctx.detail
                }, null, 8, ["defaultCollapse", "unOperate", "detail"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('vehicle'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_VehicleDetail, {
                    key: 4,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.contractId
                }, null, 8, ["defaultCollapse", "id"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('lock'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_LockVehicle, {
                    key: 5,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    vin: _ctx.detail.vinNo
                }, null, 8, ["defaultCollapse", "vin"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('disposal'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_DisposalApplication, {
                    key: 6,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.id,
                    extraData: {
                        overStatus: _ctx.detail.overStatus,
                        vehicleStatus: _ctx.detail.vehicleStatus,
                    }
                }, null, 8, ["defaultCollapse", "id", "extraData"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('collection'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CollectionList, {
                    key: 7,
                    defaultCollapse: _ctx.defaultCollapse,
                    unOperate: _ctx.module !== true,
                    style: { "margin-top": "24px" },
                    detail: _ctx.detail
                }, null, 8, ["defaultCollapse", "unOperate", "detail"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('contracts'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ContactsList, {
                    key: 8,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.id
                }, null, 8, ["defaultCollapse", "id"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('letter'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_LetterReminder, {
                    key: 9,
                    defaultCollapse: _ctx.defaultCollapse,
                    unOperate: _ctx.module !== true,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.id
                }, null, 8, ["defaultCollapse", "unOperate", "id"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('message'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MessageList, {
                    key: 10,
                    defaultCollapse: _ctx.defaultCollapse,
                    unOperate: _ctx.module !== true,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.contractNumber
                }, null, 8, ["defaultCollapse", "unOperate", "id"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('guarantor'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_GuarantorList, {
                    key: 11,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.contractId,
                    overdueRecordId: _ctx.detail.id,
                    extraData: {
                        overStatus: _ctx.detail.overStatus
                    }
                }, null, 8, ["defaultCollapse", "id", "overdueRecordId", "extraData"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.hasModule('deduction'))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_DeductionList, {
                    key: 12,
                    defaultCollapse: _ctx.defaultCollapse,
                    style: { "margin-top": "24px" },
                    id: _ctx.detail.contractId
                }, null, 8, ["defaultCollapse", "id"]))
                : (0, vue_1.createCommentVNode)("", true)
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
exports.render = render;
